export default {
  compactData: state => state.compactData,
  compactCount: state => state.compactCount,
  compactType: state => state.compactType,
  serviceContent: state => state.serviceContent,
  settlementType: state => state.settlementType,
  busiSelectData: state => state.busiSelectData,
  customSelectData: state => state.customSelectData,
  compactDetail: state => state.compactDetail,
  returndRecord: state => state.returndRecord,
  returndRecordDetail: state => state.returndRecordDetail,
  billsRecord: state => state.billsRecord,
  billsRecordDetail: state => state.billsRecordDetail,
  compactFileData: state => state.compactFileData,
  compactCostData: state => state.compactCostData,
  compactCostType: state => state.compactCostType,
  coprationDepartment: state => state.coprationDepartment,
  compactTeams: state => state.compactTeams,
  signingForm: state => state.signingForm,
  compactSalesman: state => state.compactSalesman,
  moneyBackData: state => state.moneyBackData,
  costDataList: state => state.costDataList,
  payDataList: state => state.payDataList,
  compactPayType: state => state.compactPayType,
  spendDataList: state => state.spendDataList,
  spendSalesList: state => state.spendSalesList,
  spendDetail: state => state.spendDetail,
};
